import { useEffect, useRef } from 'react';
import { fromEvent, tap, throttleTime } from 'rxjs';

import { Button } from '@nf/ui';
import { RefreshIcon } from '@/components/icons/svg-icons';

interface RefreshButtonProps {
	spinStarted: boolean;
	onRefresh?: (e: Event) => void
}

export const RefreshButton = ({ spinStarted = false, onRefresh }: RefreshButtonProps) => {
	const buttonRef = useRef<HTMLButtonElement>(null);
	useEffect(() => {
		if (!buttonRef.current) return;

		const subscription = fromEvent(buttonRef.current, 'click')
			.pipe(
				tap(e => e.stopPropagation()),
				throttleTime(2000))
			.subscribe((e) => {
				onRefresh && onRefresh(e);
			});

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	return (
		<Button
			ref={buttonRef}
			variant="icon"
			data-active={spinStarted}
		>
			<RefreshIcon />
		</Button>
	);
};